"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortfolioBuilderPath = void 0;
exports.PortfolioBuilderPath = {
    portfolioSteps: 'steps',
    buildYourPortfolio: 'build-your-portfolio',
    chooseAccounts: 'choose-accounts',
    targetAssetMix: 'target-asset-mix',
    fundManagementExplorer: 'fund-management-explorer',
    enroll: 'enroll',
    projectedPortfolio: 'projected-portfolio',
    congratulations: 'congratulations',
    success: 'success',
    vmapCongratulations: 'vmap-congratulations',
    iroError: 'iro-error',
    error: 'error',
};
